import { BaseEnvironment } from '@mkp/shared/models';

export interface MetaTag {
  name: string;
  content: string;
}

type MetaTagEnvName = Exclude<BaseEnvironment['name'], 'local' | 'qa'>;

export const getAppMetaTags = (env: BaseEnvironment): Record<MetaTagEnvName, MetaTag[]> => ({
  dev: [
    { name: 'description', content: 'META_DESCRIPTION_DEV' },
    { name: 'creator', content: 'META_CREATOR_DEV' },
    { name: 'application-name', content: 'META_NAME_DEV' },
    { name: 'keywords', content: 'META_KEYWORDS_DEV' },
    { name: 'robots', content: 'noindex' },
  ],
  stage: [
    { name: 'description', content: 'META_DESCRIPTION_DEV' },
    { name: 'creator', content: 'META_CREATOR_DEV' },
    { name: 'application-name', content: 'META_NAME_DEV' },
    { name: 'keywords', content: 'META_KEYWORDS_DEV' },
    { name: 'robots', content: 'noindex' },
    { name: 'app-version', content: env.version },
    { name: 'app-hash', content: env.hash },
  ],
  prod: [
    { name: 'description', content: 'META_DESCRIPTION' },
    { name: 'creator', content: 'META_CREATOR' },
    { name: 'application-name', content: 'META_NAME' },
    { name: 'keywords', content: 'META_KEYWORDS' },
    { name: 'robots', content: 'index' },
    { name: 'app-version', content: env.version },
    { name: 'app-hash', content: env.hash },
  ],
});
